import React from 'react';
import classNames from 'classnames';

import css from './ExtraIcons.module.css';

const HEART = 'heart';
const HEART_ICON = 'heartIcon';
const HEART_OUTLINE = 'heartOutline';
const CROSS = 'cross';
const PLAY_ICON = 'playIcon';
export const RESCHEDULE = 'reschedule';
export const CONTACT = 'contact';

/**
 * Payment card icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {'heart' | 'heartIcon' | 'heartOutline' | 'playIcon' | 'cross'} props.icon
 * @returns {JSX.Element} SVG icon
 */
const ExtraIcons = props => {
  const { className, rootClassName, icon = 'default', strokeColor = '#00B8A9' } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (icon) {
    case PLAY_ICON:
      return (
        <svg
          width="80px"
          height="80px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11" fill="grey" strokeWidth="1.5" />
          <path
            d="M9 17V7L17 12L9 17Z"
            fill="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case CROSS:
      return (
        <svg
          width="10px"
          height="10px"
          viewBox="0 0 10 10"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g strokeWidth="1" fillRule="evenodd">
            <g transform="translate(-821.000000, -311.000000)">
              <g transform="translate(809.000000, 299.000000)">
                <path
                  d="M21.5833333,16.5833333 L17.4166667,16.5833333 L17.4166667,12.4170833 C17.4166667,12.1866667 17.2391667,12 17.00875,12 C16.77875,12 16.5920833,12.18625 16.5920833,12.41625 L16.5883333,16.5833333 L12.4166667,16.5833333 C12.18625,16.5833333 12,16.7695833 12,17 C12,17.23 12.18625,17.4166667 12.4166667,17.4166667 L16.5875,17.4166667 L16.5833333,21.5829167 C16.5829167,21.8129167 16.7691667,21.9995833 16.9991667,22 L16.9995833,22 C17.2295833,22 17.41625,21.81375 17.4166667,21.58375 L17.4166667,17.4166667 L21.5833333,17.4166667 C21.8133333,17.4166667 22,17.23 22,17 C22,16.7695833 21.8133333,16.5833333 21.5833333,16.5833333"
                  transform="translate(17.000000, 17.000000) rotate(-45.000000) translate(-17.000000, -17.000000) "
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case HEART:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          height="20px"
          viewBox="0 0 64 64"
          enableBackground="new 0 0 64 64"
        >
          <path
            fill="none"
            stroke={strokeColor}
            stroke-width="4"
            stroke-miterlimit="10"
            d="M32 59C32 59 3 45 3 22C3 12 10 5 19 5C25 5 30 9 32 13C34 9 39 5 45 5C54 5 61 12 61 22C61 45 32 59 32 59Z"
          />
        </svg>
      );
    case HEART_OUTLINE:
      return (
        <svg viewBox="0 0 1024 1024" fill="currentColor" height="30px" width="30px">
          <path d="M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z" />
        </svg>
      );
    case HEART_ICON:
      return (
        <svg viewBox="0 0 1024 1024" fill="currentColor" height="30px" width="30px">
          <path d="M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z" />
        </svg>
      );

    case RESCHEDULE:
      return (
        <svg
          className={classes}
          width="48px"
          height="48px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M602,69L584,69C583.448,69 583,68.552 583,68C583,67.127 583,66 583,66C583,65.204 583.316,64.441 583.879,63.879C584.441,63.316 585.204,63 586,63L588,63L588,61.5C588,61.367 588.053,61.24 588.146,61.146C588.24,61.053 588.367,61 588.5,61C588.633,61 588.76,61.053 588.854,61.146C588.947,61.24 589,61.367 589,61.5L589,63L597,63L597,61.5C597,61.367 597.053,61.24 597.146,61.146C597.24,61.053 597.367,61 597.5,61C597.633,61 597.76,61.053 597.854,61.146C597.947,61.24 598,61.367 598,61.5L598,63L600,63C600.796,63 601.559,63.316 602.121,63.879C602.684,64.441 603,65.204 603,66L603,78C603,78.796 602.684,79.559 602.121,80.121C601.559,80.684 600.796,81 600,81C596.949,81 586.858,81 584.497,81C584.365,81 584.239,80.948 584.146,80.854C584.052,80.761 584,80.635 584,80.503C584,80.502 584,80.501 584,80.5C584,80.367 584.053,80.24 584.146,80.146C584.24,80.053 584.367,80 584.5,80C587.208,80 600,80 600,80C600.53,80 601.039,79.789 601.414,79.414C601.789,79.039 602,78.53 602,78L602,69ZM582.707,77L583.854,78.146C584.049,78.341 584.049,78.658 583.854,78.853C583.658,79.049 583.342,79.049 583.146,78.853L581.146,76.853C580.951,76.658 580.951,76.342 581.146,76.146L583.146,74.146C583.342,73.951 583.658,73.951 583.854,74.146C584.049,74.341 584.049,74.658 583.854,74.853L582.707,76L590.5,76C590.776,76 591,76.224 591,76.5C591,76.776 590.776,77 590.5,77L582.707,77ZM589.293,72L581.5,72C581.224,72 581,72.224 581,72.5C581,72.776 581.224,73 581.5,73L589.293,73L588.146,74.146C587.951,74.341 587.951,74.658 588.146,74.853C588.341,75.049 588.658,75.049 588.853,74.853L590.853,72.853C591.049,72.658 591.049,72.342 590.853,72.146L588.853,70.146C588.658,69.951 588.341,69.951 588.146,70.146C587.951,70.341 587.951,70.658 588.146,70.853L589.293,72ZM588,64L586,64C585.47,64 584.961,64.211 584.586,64.586C584.211,64.961 584,65.47 584,66L584,68L602,68L602,66C602,65.47 601.789,64.961 601.414,64.586C601.039,64.211 600.53,64 600,64L598,64L598,65.5C598,65.633 597.947,65.76 597.854,65.854C597.76,65.947 597.633,66 597.5,66C597.367,66 597.24,65.947 597.146,65.854C597.053,65.76 597,65.633 597,65.5L597,64L589,64L589,65.5C589,65.633 588.947,65.76 588.854,65.854C588.76,65.947 588.633,66 588.5,66C588.367,66 588.24,65.947 588.146,65.854C588.053,65.76 588,65.633 588,65.5L588,64Z"
            transform="translate(-580 -60)"
          ></path>
        </svg>
      );
    case CONTACT:
      return (
        <svg
          className={classes}
          width="48px"
          height="48px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M13 2a9 9 0 0 1 9 9" />
          <path d="M13 6a5 5 0 0 1 5 5" />
          <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
        </svg>
      );

    default:
      return null;
  }
};

export default ExtraIcons;
